import { useEffect, useState } from 'react';
import './particle-background.scss';
import { useTheme } from '../../../contexts/themeContext';
import { loadSlim } from '@tsparticles/slim';
import { getParticleOptions } from './options';
import Particles, { initParticlesEngine } from '@tsparticles/react';
import { type Container } from '@tsparticles/engine';

interface ParticlesBackgroundProps {
  isHeaderMinified: boolean;
}

const ParticlesBackground: React.FC<ParticlesBackgroundProps> = ({ isHeaderMinified }) => {
  const [init, setInit] = useState(false);
  const { theme } = useTheme();

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const particlesLoaded = async (container?: Container): Promise<void> => {
    console.log(container);
  };

  if (!init) return null;

  return (
    <Particles
      id="tsparticles"
      particlesLoaded={particlesLoaded}
      options={getParticleOptions(theme)}
    />
  );
};

export default ParticlesBackground;
